import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ToastrModule } from "ngx-toastr";
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

import { SidebarModule } from './sidebar/sidebar.module';
import { FooterModule } from './shared/footer/footer.module';
import { NavbarModule} from './shared/navbar/navbar.module';
import { FixedPluginModule} from './shared/fixedplugin/fixedplugin.module';

import { AppComponent } from './app.component';
import { AppRoutes } from './app.routing';

import { AdminLayoutComponent } from './layouts/admin-layout/admin-layout.component';
import { NgProgressModule } from "ngx-progressbar";
// import player from 'lottie-web';
import { LottieModule } from "ngx-lottie";
import { NgxIntlTelInputModule } from "ngx-intl-tel-input";
import { AuthInterceptor } from "./modules/auth/_services/auth.interceptor";
import { GooglePlaceModule } from "ngx-google-places-autocomplete";
import { InfiniteScrollModule } from "ngx-infinite-scroll";
import { WebcamModule } from "ngx-webcam";
import { Angular4PaystackModule } from "angular4-paystack";
import { environment } from "environments/environment";
// import { AngularFireModule } from "@angular/fire/compat";
// import { AngularFireAuthModule } from "@angular/fire/compat/auth";
import { LoaderService } from "./shared/services/loader.service";
import { LoaderInterceptor } from "./interceptors/loader-interceptor.service";
import { LoaderComponent } from "./shared/loader/loader.component";
import { ErrorHandlingInterceptor } from "./interceptors/error-handling.interceptor";
import { NgxQRCodeModule } from '@techiediaries/ngx-qrcode';
import { LegalDocumentationModule } from "./modules/legal-documentation/legal-documentation.module";
import { ChatService } from "./modules/messages/chat.service";
// import { SocketIoModule, SocketIoConfig } from "ngx-socket-io";
// import { ChartsModule } from 'ng2-charts';


// export function playerFactory() {
//   return player;
// }
// const config: SocketIoConfig = {
//   url: "https://sandbox-api.invitte.app",
//   options: {},
// };
@NgModule({
  declarations: [AppComponent, AdminLayoutComponent, LoaderComponent],
  imports: [
    BrowserAnimationsModule,
    RouterModule.forRoot(AppRoutes, {
      useHash: true,
      scrollPositionRestoration: "enabled",
    }),
    
    // SocketIoModule.forRoot(config),
    SidebarModule,
    NavbarModule,
    ToastrModule.forRoot(),
    FooterModule,
    FixedPluginModule,
    HttpClientModule,
    NgProgressModule,
    // LottieModule.forRoot({ player: playerFactory }),
    GooglePlaceModule,
    LegalDocumentationModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    ChatService,
    LoaderService,
    { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
    // {
    //   provide: HTTP_INTERCEPTORS,
    //   useClass: ErrorHandlingInterceptor,
    //   multi: true,
    // },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
